import React from 'react';
import Card from '../Card';
import UserPlayer from '../../entities/players/UserPlayer';
import Constants from '../../constants/Constants';

export default class SwitchStackCard extends Card {

    onAfterCardThrownFromPlayerToUsedPile = async () => {
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_SWITCH_STACK_CARD);

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        cEntity.setFinalUserEvent();

        if (cEntity instanceof UserPlayer) {
            await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
            await this.userPlayerSwitchCardWithStackMove();

        }
        else {

            await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
            await this.computerPlayerSwitchCardWithStackMove();
        }
    }

    // COMPUTER PLYER MOVE

    computerPlayerSwitchCardWithStackMove = async () => {
        // this.gameCtx.soundRepository.playSoundByName(Constants.SWITCH_CARD)

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        let enemyEntity = cEntity.chooseEnemyCard();
        
        // if userPlayer --> inform
        if (enemyEntity instanceof UserPlayer) {
            let text = <div className="popup-text interval-popup-text increasd-text">הותקפת בקלף "החלף לחבר קלף עם הקופה"!</div>;
            cEntity.addPopupWithInterval(text);
            await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);
            this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);
        }

        await this.gameCtx.moveCard(enemyEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.enemyChosenCard, false, true);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        await enemyEntity.getCardsFromNewPile(1);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        cEntity.resolvePlayerFinal();
    }

    // USER PLAYER MOVE

    userPlayerSwitchCardWithStackMove = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        if (cEntity.isTimeForActionCardsEventsUp()) {
            let text = <div className="popup-text interval-popup-text increasd-text">קלף "החלף לחבר קלף עם הקופה" נכנס לפעולה!</div>;
            cEntity.addPopupWithInterval(text);
            await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);
            this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);

            cEntity.addBubbleOnBottomPlayer("בחר קלף להחלפה מאחד היריבים", Constants.ELEMENT_ENEMIES_SWITCH_A_CARD);

            let entities = this.gameCtx.gameSeqHandler.getAllCurrentEntityEnemies();
            let entityEvents = [];
            cEntity.waitingEntities = [];

            entities.forEach(async entity => {

                let cb = (chosenCard) => { cEntity.enemyChosenCard = chosenCard };
                entity.standInEntities = this.gameCtx.gameSeqHandler.getEnemiesOfEntityWithoutCurrentPlayer(entity);
                entity.subscribeUserEventToCards(
                    (cardObj) => entity.handleChooseCardEvent(cardObj, false, false, cb, false),
                    Constants.FLAGS_MULTIPLE_TIME_USE);

                entityEvents.push(entity.waitForEvent());
                cEntity.waitingEntities.push(entity);
            });

            await Promise.race(entityEvents);

            this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_ENEMIES_SWITCH_A_CARD);

            entities.forEach(entity => entity.unsubscribeEventToCards());

            if (cEntity.enemyChosenCard) {
                let enemyEntity = cEntity.enemyChosenCard.ref.current.getOwner();
                // this.gameCtx.soundRepository.playSoundByName(Constants.SWITCH_CARD);
                await this.gameCtx.moveCard(enemyEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.enemyChosenCard, false, true);
                await enemyEntity.getCardsFromNewPile(1);
                await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
            }
        }
        else {
            cEntity.informTimesUp();
        }

        cEntity.resolvePlayerFinal();
    }
}